/**
 * Landing page static content & asset URLs.
 * Update logo/image URLs here — used across all landing sections.
 */

export const LANDING_ASSETS = {
  heroBackground: 'https://hype.com.tr/wp-content/uploads/2025/10/Mask-group-scaled.jpg',
  // Separate logos for transparent header (top) vs scrolled (white header)
  logo: {
    desktop: {
      hero: 'https://hype.com.tr/wp-content/uploads/2020/12/hype_logo-nobg-white-w1200.png',
      scrolled: 'https://hype.com.tr/wp-content/uploads/2020/12/hype_logo-nobg-dark-w1200.png',
    },
    mobile: {
      hero: 'https://hype.com.tr/wp-content/uploads/2020/12/h_only-nobg-white-w200.png',
      scrolled: 'https://hype.com.tr/wp-content/uploads/2020/12/hype_logo-nobg-dark-w300.png',
    },
  },
  heroWave: 'https://www.figma.com/api/mcp/asset/64ff0b24-bc9d-464b-a7cd-e0fee45e4242',
  heroBadgeMedal: 'https://www.figma.com/api/mcp/asset/52d97103-0184-45b0-aaf4-e4bb105b4aae',
  heroFormThumb: 'https://www.figma.com/api/mcp/asset/52d97103-0184-45b0-aaf4-e4bb105b4aae',
  processIllustration: 'https://hype.com.tr/wp-content/uploads/2025/11/Group-2213.png',
  footerBg: 'https://www.figma.com/api/mcp/asset/17dc7c5a-59ff-4cbd-b30f-21333fe80f0e',
  clientLogos: [
    { name: 'Pegasus', url: 'https://hype.com.tr/wp-content/uploads/2025/10/pegasus-logo.png', width: 162, height: 27 },
    { name: 'İpragaz', url: 'https://hype.com.tr/wp-content/uploads/2025/10/ipragaz-logo.png', width: 162, height: 39 },
    { name: 'AgeSA', url: 'https://hype.com.tr/wp-content/uploads/2025/10/agesa-logo.png', width: 138, height: 37 },
    { name: 'Koç Ailem', url: 'https://hype.com.tr/wp-content/uploads/2025/10/kocailem-logo.png', width: 91, height: 91 },
    { name: 'Zurich', url: 'https://hype.com.tr/wp-content/uploads/2025/10/zurich-logo.png', width: 186, height: 44 },
  ],
};

export const NAV_LINKS = [
  { label: 'Hizmetlerimiz', href: '#process' },
  { label: 'Başarı Hikayeleri', href: '#stories' },
  { label: 'AB Test Hesaplayıcı', href: '/calculator', internal: true },
  { label: 'Yöntemler Rehberi', href: '/methods-guide', internal: true },
  { label: 'Metrik Rehberi', href: '/calculation-guide', internal: true },
  { label: 'İletişim', href: '#contact' },
  { label: 'Dashboard', href: '/dashboard', internal: true },
];

export const HERO = {
  badge: '👋 hype CRO Sunar',
  title: 'Tıklamaları gelire çeviren modern optimizasyon',
  subtitle:
    'Modern optimizasyon stratejileriyle tıklamaları gerçek gelire dönüştürün. Veriye dayalı aksiyonlarla ölçün, test edin, büyütün.',
  formTitle: 'Şimdi Teklif Alın',
  formSubtitle: 'Talebinizi iletin, ekibimiz en kısa süre içinde size dönüş yapsın.',
};

export const SUCCESS_STORIES = [
  {
    id: 'ipragaz',
    brand: 'İpragaz',
    brandLogo: 'https://hype.com.tr/wp-content/uploads/2025/10/ipragaz-logo.png',
    brandLogoWidth: 162,
    brandLogoHeight: 39,
    title: 'Ürün Gösterim Redesign Testi',
    hypothesis:
      'Liste görünümü sayesinde kullanıcılar ürünleri daha kolay karşılaştırabilir, kampanya ve fiyat bilgisini daha net görebilir. Bu sade ve odaklı yapı, daha fazla ürün sunarak “Sepete Ekle” çağrısını güçlendirerek sepete ekleme oranlarını artıracaktır.',
    impact:
      'Bu test, kullanıcıların ürünleri daha net görüp hızlı karar verebilmesini sağlayarak sepete ekleme oranında %9,38, satın alma oranında %17,74 artış yaratmıştır. Bu da liste görünümünün kullanıcı deneyimini sadeleştirip gelir artışına doğrudan katkı sağladığını göstermektedir.',
    metrics: [
      { label: 'Add to Cart', sub: 'Uplift', value: '+9.38%' },
      { label: 'Purchase', sub: 'Uplift', value: '+17.74%' },
      { label: 'Yıllık Ekstra Kazanç', sub: 'Sipariş Adedi', value: '+8.192' },
    ],
    originalImage: 'https://www.figma.com/api/mcp/asset/45ad312d-5f24-473e-9e83-4b51a8429daf',
    variationImage: 'https://www.figma.com/api/mcp/asset/45ad312d-5f24-473e-9e83-4b51a8429daf',
    imagePosition: 'left',
  },
  {
    id: 'agesa',
    brand: 'AgeSA',
    brandLogo: 'https://hype.com.tr/wp-content/uploads/2025/10/agesa-logo.png',
    brandLogoWidth: 138,
    brandLogoHeight: 37,
    title: 'Başvuru Formu Re-Design',
    hypothesis:
      'BES başvuru formunu fold üstüne taşıyıp sayfa girişindeki görsel ve metin ağırlığını azaltarak form alanını daha görünür ve erişilebilir hale getirdiğimizde, kullanıcılar formu daha hızlı fark edip doldurmaya başlayabilir ve bu sayede form başlama oranı ve başvuru tamamlama oranı orijinale kıyasla artabilir.',
    impact:
      'Formun fold üstüne alınmasıyla kullanıcı formu daha hızlı fark ederek doldurmaya başladı. V1 varyasyonu form gönderimlerinde %100,93 artış sağladı. Bu iyileştirme aylık +443, yıllık +5.393 ek başvuru potansiyeli sunarak dönüşüm performansına güçlü bir katkı yarattı.',
    metrics: [
      { label: 'Form Submit', sub: 'Uplift', value: '+33.55%' },
      { label: 'Yıllık Ekstra Kazanç', sub: 'Form Başvurusu', value: '+3.459' },
    ],
    originalImage: 'https://www.figma.com/api/mcp/asset/0518f930-b755-4e4d-825e-63a341dd036d',
    variationImage: 'https://www.figma.com/api/mcp/asset/2eafc341-e3da-4356-a667-6db92119e33c',
    imagePosition: 'right',
  },
];

export const PROCESS = {
  title: 'Basit, hızlı ve etkili süreç',
  description: [
    'CRO (Conversion Rate Optimization), bir web sitesinin ya da dijital ürünün ziyaretçilerini hedeflenen aksiyona yönlendirme oranını artırmayı amaçlayan sistematik bir süreçtir. Bu süreçte kullanıcı davranışları analiz edilir, veri odaklı hipotezler geliştirilir ve farklı tasarım veya içerik varyasyonları test edilir.',
    'Elde edilen sonuçlara göre en yüksek performans gösteren varyasyonlar uygulanır ve süreç sürekli olarak tekrarlanır. Amaç, kullanıcı deneyimini geliştirerek dönüşüm oranlarını kalıcı biçimde artırmaktır.',
  ],
  ctaLabel: 'Teklif Alın - Ücretsiz',
  ctaHref: '#hero-section',
  steps: [
    {
      num: '01',
      title: 'Analiz',
      text: "Kullanıcı davranışları, dönüşüm Funnel'ı ve veriler incelenerek kayıp noktalar belirlenir.",
    },
    {
      num: '02',
      title: 'A/B Test',
      text: 'Hipotezler oluşturulur, A/B testleriyle farklı tasarım ve içerik varyasyonları karşılaştırılır.',
    },
    {
      num: '03',
      title: 'Optimizasyon',
      text: 'En başarılı varyasyon canlıya alınır; süreç sürekli veriye beslenerek tekrarlanır.',
    },
  ],
};

export const CONTACT = {
  title: 'İş hedeflerinize nasıl ulaşacağınızı ofisimizde görüşelim.',
  address: 'Esentepe Mahallesi, Ecza Sokak, Levent Cd. No:6 Şişli/ İstanbul',
  directionsUrl: 'https://maps.google.com',
  directionsLabel: 'Yol tarifi alın',
  email: 'hello@hype.com.tr',
  phone: '+90 532 744 4973',
  website: 'hype.com.tr',
  meetingUrl: 'https://hype.com.tr/iletisim',
  meetingLabel: 'Toplantı zamanı alın',
};

export const FOOTER = {
  links: [
    { label: 'Anasayfa', href: '/', internal: true },
    { label: 'Hizmetler', href: '#process' },
    { label: 'Başarı Hikayeleri', href: '#stories' },
    { label: 'AB Test Hesaplayıcı', href: '/calculator', internal: true },
    { label: 'Yöntemler Rehberi', href: '/methods-guide', internal: true },
    { label: 'Metrik Rehberi', href: '/calculation-guide', internal: true },
    { label: 'İletişim', href: '#contact' },
    { label: 'Giriş', href: '/login', internal: true },
    { label: 'Dashboard', href: '/dashboard', internal: true },
  ],
  cookiePolicy: { label: 'Çerez Politikası', href: 'https://hype.com.tr/cerez-politikasi' },
  copyright: '© Hype 2013 – 2026',
  social: [
    { label: 'Facebook', href: 'https://www.facebook.com/hypecomtr', icon: 'facebook' },
    { label: 'Medium', href: 'https://medium.com/@hypecomtr', icon: 'medium' },
    { label: 'Instagram', href: 'https://www.instagram.com/hypecomtr', icon: 'instagram' },
    { label: 'Twitter', href: 'https://twitter.com/hypecomtr', icon: 'twitter' },
    { label: 'LinkedIn', href: 'https://www.linkedin.com/company/hypecomtr', icon: 'linkedin' },
  ],
};

export const LANDING_COLORS = {
  purple: '#250c4b',
  purpleDark: '#1a0840',
  purpleLight: '#3d1578',
  purpleBtn: '#250c4b',
  badgeBg: '#31256c',
  badgeBorder: '#6016d1',
  formBorder: '#d7bcff',
  textMuted: '#8a8a8a',
  textGray: '#383838',
  green: '#0abc2a',
  redLink: '#df2b2a',
  borderLight: '#e2e2e2',
};
